<template>
    <div class="search-component search-component--mobile">
        <div class="row main-search">
            <div class="col-md-12 px-0 justify-content-between">
                <div class="row mr-sm-0 search-component--mobile-wrapper" :class="{'mb-2 mb-sm-3': !currentLocationError}">
                    <div class="px-0 col rounded-0-right searchbar-wrapper">
                        <select class="form-control select2-selection__default" id="searchLocationFilter">
                            <option value="1" v-if="locationTemp.query" selected>{{locationTemp.query}}</option>
                        </select>
                    </div>
                    <div class="px-0 radius-wrapper">
                        <select class="form-control rounded-0-left pl-1 pr-4 mx-0" id="radius"
                                @change="setSearchRadiusTemp">
                            <option v-for="(description, radius) in locationRadiuses" :value="radius"
                                    :selected="searchRadiusTemp == radius">
                                {{description}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <error-component
            v-if="currentLocationError"
           :message="translate.home.currentLocationError"
        ></error-component>
    </div>
</template>

<script>
    import searchMixin from "@/components/mixins/search/search-mixin";

    const data = () => {
        return {
            searchVariant: 'searchLocationFilter',
            locationRadiuses: constants.search_radius,
        }
    };

    function onLocationChange(e) {
        const result = _.get(e, 'params.data.result', {});
        const payload = this.buildLocationPayload(result);

        this.store.commit('setLocationTemp', payload);
    }

    function setSearchRadiusTemp(event) {
        const radius = _.get(event, 'target.value', '20km');
        this.store.commit('setSearchRadiusTemp', radius);
    }

    export default {
        data,
        mixins: [
            searchMixin,
        ],
        computed: {
            ...mapState([
                'location',
                'locationTemp',
                'searchRadiusTemp',
                'translate'
            ])
        },
        methods: {
            onLocationChange,
            setSearchRadiusTemp,
        }
    }
</script>
